<div class="col-card">
  <div class="col-head">
    <div class="col-icon"><i class="bi bi-clipboard-data"></i></div>
    <div class="col-head-text">
      <div class="col-title-row">
        <span class="col-title">Stock corrections</span>
        <span class="col-count" *ngIf="totalCount">{{ totalCount }}</span>
      </div>
      <p class="col-desc">Items whose quantity differs between Aivor and Sage.</p>
    </div>
    <button class="col-link" (click)="viewAll.emit()">View all</button>
  </div>

  <div class="paused-strip" *ngIf="!syncEnabled">
    <i class="bi bi-pause-circle"></i>
    <span>Sync is turned off, so corrections can't be released. You can still pick reasons.</span>
  </div>

  <div class="col-body" *ngIf="loading">
    <div class="col-empty"><i class="bi bi-arrow-repeat spin"></i><span>Loading&hellip;</span></div>
  </div>

  <div class="col-body" *ngIf="!loading && rows.length">
    <div class="bulk-strip" [class.active]="selected.size" *ngIf="selectableRows.length">
      <label class="check">
        <input type="checkbox" [checked]="allSelected" (change)="toggleAll()" />
        <span *ngIf="!selected.size">Select all to give them the same reason</span>
        <span *ngIf="selected.size"><b>{{ selected.size }}</b> selected</span>
      </label>
      <ng-container *ngIf="selected.size">
        <select class="reason-select" [(ngModel)]="bulkReasonId" aria-label="Reason for all selected">
          <option [ngValue]="null">Choose reason&hellip;</option>
          <option *ngFor="let r of reasons" [ngValue]="r.id">{{ r.description }}</option>
        </select>
        <button
          class="btn-solid"
          [disabled]="!bulkReasonId || !syncEnabled || bulkReleasing"
          [title]="!syncEnabled ? 'Sync is turned off' : (!bulkReasonId ? 'Choose a reason first' : '')"
          (click)="releaseSelected()"
        >
          Release {{ selected.size }}
        </button>
        <p class="row-hint d-md-none" *ngIf="!syncEnabled || !bulkReasonId">
          {{ !syncEnabled ? 'Sync is turned off' : 'Choose a reason first' }}
        </p>
      </ng-container>
    </div>

    <div class="stock-row" *ngFor="let row of rows; trackBy: trackRow" [ngClass]="stateOf(row)">
      <ng-container *ngIf="stateOf(row) as state">
        <div class="state-row">
          <i
            class="bi"
            [ngClass]="{
              'bi-arrow-repeat spin': state === 'releasing',
              'bi-check-circle-fill': state === 'applied',
              'bi-check-circle': state === 'insync',
              'bi-dash-circle': state === 'cancelled',
              'bi-info-circle': state === 'conflict'
            }"
          ></i>
          <b class="row-name">{{ row.itemName || row.itemCode }}</b>
          <span class="state-text" *ngIf="state === 'releasing'">releasing&hellip;</span>
          <span class="state-text" *ngIf="state !== 'releasing'">{{ rowMessage[row.id] }}</span>
          <span class="state-reason" *ngIf="state === 'applied' && reasonTextFor(row)">
            {{ reasonTextFor(row) }}
          </span>
        </div>
      </ng-container>

      <ng-container *ngIf="isPending(row)">
        <div class="row-top">
          <label class="check check-only">
            <input
              type="checkbox"
              [checked]="selected.has(row.id)"
              (change)="toggleRow(row)"
              [attr.aria-label]="'Select ' + (row.itemName || row.itemCode)"
            />
          </label>
          <b class="row-name">{{ row.itemName || row.itemCode }}</b>
          <span class="dir-tag">{{ directionLabel(row) }}</span>
        </div>

        <div class="row-meta">
          <span class="qty">Aivor <b>{{ row.aivorQuantity }}</b></span>
          <span class="qty">Sage <b>{{ row.sageQuantity }}</b></span>
          <span class="outcome">&rarr; {{ outcomeText(row) }}</span>
          <span class="detected">{{ relativeDayLabel(row.detectedAt) }}</span>
        </div>

        <div class="row-actions">
          <select
            class="reason-select"
            [(ngModel)]="reasonById[row.id]"
            [attr.aria-label]="'Reason for ' + (row.itemName || row.itemCode)"
          >
            <option [ngValue]="undefined">Choose reason&hellip;</option>
            <option *ngFor="let r of reasons" [ngValue]="r.id">{{ r.description }}</option>
          </select>
          <button
            class="btn-solid"
            [disabled]="!canRelease(row)"
            [title]="releaseTooltip(row)"
            (click)="release(row)"
          >
            Release
          </button>
          <button class="icon-btn" aria-label="Dismiss" title="Dismiss this correction" (click)="dismiss(row)">
            <i class="bi bi-x"></i>
          </button>
        </div>
        <p class="row-hint d-md-none" *ngIf="releaseTooltip(row)">{{ releaseTooltip(row) }}</p>

        <p class="row-error" *ngIf="rowError[row.id]">{{ rowError[row.id] }}</p>
      </ng-container>
    </div>
  </div>

  <div class="col-body" *ngIf="!loading && !rows.length">
    <div class="col-empty">
      <i class="bi bi-check-circle"></i>
      <span>Aivor and Sage stock match</span>
    </div>
  </div>

  <div class="col-foot" *ngIf="rows.length">
    <span>Showing {{ rows.length }} of {{ totalCount }}</span>
    <button class="col-link" (click)="viewAll.emit()">View all</button>
  </div>
</div>
